<template>
    <div>
            <q-toolbar color="primary" style="justify-content:space-between;">
                <q-toolbar-title shrink>
                    <default-sizes v-on:defaultSize="setDefaultSize"/>
                </q-toolbar-title>
                <q-btn flat icon="cancel" dense color="red" style="background: #DDDDDD" @click="deleteThisFile"/>
            </q-toolbar>
        <div class="row no-wrap justify-center param_contrainer">

            <div class="leftColumn">
                <table width="100%">
                    <tr>
                        <td>
                            <q-input 
                                name="file_width"
                                v-model="fileWidth" 
                                suffix="м"  
                                placeholder="Ширина (м):" 
                                class="param-input"  
                                type="number" 
                                autofocus 
                                v-validate="{required : true}"
                                style="float:left"
                                />
                            <q-input 
                                name="file_height"
                                v-model="fileHeight" 
                                suffix="м" 
                                placeholder="Высота (м):" 
                                class="param-input" 
                                style="float:left;" 
                                v-validate="{required : true}"
                                type="number"
                            />
                        </td>
                        <td width="80px">
                            <div class="switch-container">
                                <q-btn round color="primary" icon="import_export" @click="switch_WH"/>
                            </div>
                        </td>
                    </tr>
                </table>
                <q-input v-model="fileComment" placeholder="Имя файла" class="param-input"  @blur="saveParam" />
            </div>
            <div class="rightColumn">
                <div v-if="loaded">
                   <img :src ="image" class="preview">
                </div>
                <progress v-if="!loaded" max="100" :value.prop="uploadPercentage"></progress>               
            </div>
        </div>
    </div>


</template>

<script>
/* eslint-disable */
import axios from 'axios'
import s3 from 'axios'
import defaultSizes from './defaultSizes'



export default {
    props:{
            fieldData : {
                type : Object,
                required : true,
            }

    },
    components :{
        defaultSizes,
    },

    data () {
        return {
            uploadPercentage: 0,

            fileLoaded : false,

            thisFileData : {
                width : null,
                height : null,
                comment : null,
                number : 1,
                file : null,
                name : null,
                id : this.fieldData.id,
            },

        }
    },

  
    created(){ // инициируем загрузку
     
        this.loadFile();

    },

    computed : {

        fileData : {
            get: function() {
                return this.fieldData.fileData;
            },
            set: function (newValue) {
                this.fieldData.fileData = newValue;
            }
        },

        upLoadFile() {
            return this.fileData.file
        },
       
        loaded: {
            get: function() {
                return this.fileLoaded;
            },
            set: function (newValue) {
                this.fileLoaded = newValue;
            }
        },

        image() {
            if (this.thisFileData.file != null)
                return this.thisFileData.file;
            return "";
        },

        fileWidth: {
            get: function () {
                return this.thisFileData.width
            },
            set: function (newValue) {
                this.thisFileData.width = newValue;
                this.saveParam();
            }
        },

        fileHeight: {
            get: function () {
                return this.thisFileData.height
            },
            set: function (newValue) {
                this.thisFileData.height = newValue;
                this.saveParam();
            }
        },

        fileComment : {
            get: function () {
                return this.thisFileData.comment
            },
            set: function (newValue) {
                this.thisFileData.comment = newValue;
                this.saveParam();
            }
        }

    },
    
    beforeDestroy () {
            //удаляем файл превью
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.token;
            axios.delete('/upload', {
                params : {file : this.thisFileData.name}
            })
            .then(()=>{

            });
    },
   
    methods : {
        
        saveParam() {
          this.$store.commit('saveFileParam', this.thisFileData);
        //   console.log(this.thisFileData)
        },

        parseFileName(data) {
            this.thisFileData.name = data.name;
            this.thisFileData.file = data.file;
            this.fileLoaded = true;

            var st = data.name;
            var parts = st.split('_');
            const index = st.indexOf('_')+1;
            this.fileComment = st.substring(index, st.length);

            var sizeSt = parts[1];
            parts = sizeSt.split('x'); // по анг
            if (parts.length>1) { //значит пробуем забить размеры
                this.fileWidth = parts[0].replace(/,/, '.');
                this.fileHeight = parts[1].replace(/,/, '.');
            } else { // по-русски
                parts = sizeSt.split('х');
                if (parts.length>1) {
                    this.fileWidth = parts[0].replace(/,/, '.');
                    this.fileHeight = parts[1].replace(/,/, '.');
                }
            }
            if (this.fileWidth>100) this.fileWidth /=1000; // наверное задано в миллиметрах - пробуем перегнать в метры
            if (this.fileHeight>100) this.fileHeight /=1000; // наверное задано в миллиметрах - пробуем перегнать в метры
        },

        setDefaultSize(param){
            this.fileWidth = param.width;
            this.fileHeight = param.height;
        },

        deleteThisFile() {
            eventBus.$emit("deleteUploadFile", this.fieldData.id);           
        },

        switch_WH() {
            var q = this.fileWidth;
            this.fileWidth = this.fileHeight;
            this.fileHeight = q;
        },

        loadFile(){

            
            var self = this;
          
            var formData = new FormData();
           
            var file = this.fieldData.file;
            

            formData.append('files[0]', file);


                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.token;
                axios.post( '/upload',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: function( progressEvent ) {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                    }.bind(this)
                    }
                ).then(function(responce){

                    self.parseFileName(responce.data); // парсим имя файла - заполняем размеры и комменты

                })
                .catch((error)=>{console.log(error);});
            
        },

    },

}

</script>


<style lang="scss" scoped>
    .param_contrainer {
        margin-bottom: 10px;
    }
    .swith-container {
        width:60px; border: 1px solid black; float:right; height:150px;
    }

    .param-input  {
        background : white;
        padding : 10px;
        margin: 10px;
        width: 100%;
        
    }

    .rightColumn {
        
        width: 55%;
        line-height: 50px;
       
        padding-top: 10px;
        
        border-right : 1px solid lightgray;
        border-bottom: 1px solid lightgray;
        background: rgb(233, 233, 233);
        
    }

    .leftColumn {
        width: 45%;
        text-align: left;
        border-left : 1px solid lightgray;
        border-bottom: 1px solid lightgray;
        background: rgb(233, 233, 233);
        padding : 10px;
    }

    .file-title {
        height:40px;
        background: #027be3;
    }

    .preview {
        margin-top: 10px;
        padding : 10px;
        background :white;
        margin: auto;
        max-width:400px;
        width : 65%;
        border:1px solid rgb(207, 207, 207);
    }

</style>
